<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <doviz ref="doviz" @setCurrencyValue="setCurrency($event)"></doviz>
    <div v-show="!loadingvmodel">
       <v-dialog v-model="threedConfirmDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline">{{ $t('Confirmation') }}</v-card-title>
        <v-card-text>
          {{ 'KARTINIZDAN 3D ONAYI OLMADAN' }}  {{this.footerTotalFare | moneyformat}} {{ '₺' }}  {{ 'TUTAR ÇEKİLECEK ONAYLIYOR MUSUNUZ?' }} 
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" @click="threedConfirmDialog = false">
            {{ $t('Cancel') }}
          </v-btn>
          <v-btn color="error" @click="creditCardPayment()">
            {{ $t('Yes') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
     <v-layout row justify-center>

<v-dialog v-model="creditCardInfo" persistent max-width="850px">
 <v-flex ma-2 xs12 sm12 md12>
                            <v-card flat class="white--text">
                               
                                    <v-card-actions>
                                        <v-flex xs12 ma-2  sm6 md6>
                                            <v-layout justify-start>
                                                <v-icon color="pink">credit_card</v-icon> &nbsp; <span
                                                    class="title pink--text font-weight-regular">
                                                    {{ $t('Credit-Card-Details') }}
                                                </span>
                                            </v-layout>
                                            <v-divider></v-divider>
                                            <v-form ref="formodeme" v-model="validOdeme" lazy-validation>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm12 md12>
                                                        <v-text-field
                                                            :rules="[rules.required]"
                                                            v-model="PaymentForm.CardNumber" :label="$t('Credit-Card-No')"
                                                          hide-details=""    mask="####-####-####-####">
                                                        </v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md12>

                                                    </v-flex>

                                                    <v-flex xs12 sm12 md12>
                                                        <v-text-field v-model="PaymentForm.CardHolder"
                                                             :rules="[rules.required]"
                                                            hide-details=""  :label="$t('Name-on-Card')">
                                                        </v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md6>
                                                        <v-select :items="sonkullanimAy" :label="$t('Expiry-Month')"
                                                            v-model="PaymentForm.ExpirationMonth"
                                                             :rules="[rules.required]"
                                                             hide-details=""  item-text="text" item-value="id">
                                                        </v-select>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md6>
                                                        <v-select :items="sonkullanimYil"
                                                            v-model="PaymentForm.ExpirationYear"
                                                            :label="$t('Expiry-Year')"
                                                             :rules="[rules.required]"
                                                              hide-details="" item-text="text" item-value="id">
                                                        </v-select>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md4>
                                                        <v-text-field label="CVV" v-model="PaymentForm.Cvv"
                                                            :rules="[rules.required]"
                                                           hide-details="" mask="###">
                                                        </v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                            </v-form>
                                        </v-flex>

                                        <v-flex xs12 sm6 ma-2 md6>
                                            <v-card flat class="white--text">
                                                <v-card flat="">
                                                    <v-card-actions>
                                                        <v-layout align-end="" row wrap>

                                                            <v-flex xs12 sm6 ma-2 md12>
                                                                <v-layout justify-center>
                                                                    <div>
                                                                      
                                                                       
                                                                        <v-divider></v-divider>
                                                                        <v-layout pa-2 justify-center>
                                                                            <div
                                                                                class="font-weight-regular red--text display-1 mb-2">
                                                                                {{this.footerTotalFare | moneyformat}} ₺
                                                                            </div>
                                                                        </v-layout>
                                                                     
                                                                        <v-layout justify-center>
                                                                            <v-btn  block
                                                                                class="white--text" @click="creditCardInfo=false"
                                                                                color="green">
                                                                                {{ $t('Cancel') }} <v-icon>clear
                                                                                </v-icon>
                                                                                </v-btn>
                                                                            <v-btn  block
                                                                                class="white--text"
                                                                                @click="confirmthereed()" color="green">
                                                                                {{$t('Make-Payment')}} &nbsp;<v-icon>done
                                                                                </v-icon>
                                                                            </v-btn>
                                                                        </v-layout>

                                                                    </div>
                                                                </v-layout>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-card>
                                        </v-flex>

                                        
                                    </v-card-actions>
                              
                            </v-card>
                        </v-flex>

    </v-dialog>

     </v-layout>
    
    <v-form ref="formTicket" v-model="valid">
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{ $t("Passenger-Details") }} </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-flex>
        </v-layout>
        <v-layout row wrap pa-2>
          <!-- BILGILER -->

          <!-- Yolcu Bilgileri -->
          <v-flex xs12 sm8 md8 pr-2 v-if="ticketAllocate.length > 0">
            <v-card class="pa-2 mb-2">
              <v-layout class="project overdue" row wrap>
                <v-flex xs12 pb-2 sm12 md12>
                  <v-layout row wrap>
                    <v-toolbar flat="" size="120px" dark color="white">
                      <v-toolbar-title>
                        <span class="header black--text">
                          {{ $t("Passenger-Details") }}
                        </span>
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </v-layout>
                </v-flex>
              </v-layout>
              <!-- Yolcularin Bilgileri -->

              <v-layout
                row
                wrap
                v-for="(paxs, ind) in paxList"
                v-bind:key="ind"
              >
                <v-flex xs12 sm10 md10 class="title my-auto">
                  {{ ind + 1 }} . {{ paxs.PaxType | passengerType }}
                  {{ $t("Passenger") }}
                </v-flex>
                <v-flex>
                  <v-checkbox
                    @change="defaultContact(paxs, ind)"
                    :disabled="isUpdate"
                    v-model="contactValueList[ind]"
                    :label="$t('Default-Contact')"
                  ></v-checkbox>
                </v-flex>

                <v-flex xs12 sm3 md3>
                  <v-select
                    :label="$t('Sex-v2')"
                    :items="genderItems"
                    item-text="text"
                    item-value="value"
                    v-model="paxs.Gender"
                    :rules="[rules.required]"
                    :disabled="isUpdate"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    :label="$t('Name_label')"
                    v-model="paxs.FirstName"
                    @change="changeFirstName(paxs.FirstName)"
                    :disabled="isUpdate"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    :label="$t('Surname_label')"
                    v-model="paxs.LastName"
                    @change="changeLastName(paxs.LastName)"
                    :disabled="isUpdate"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    :label="$t('Email_label')"
                    v-model="paxs.Email"
                    @change="changeEmail(paxs.Email)"
                    :disabled="isUpdate"
                    :rules="[rules.required, rules.email]"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm3 md3>
                  <v-autocomplete
                    :label="$t('Nationality')"
                    :items="countryItems"
                    item-text="name"
                    item-value="code"
                    v-model="paxs.Nationality"
                    :rules="[rules.required]"
                    :disabled="isUpdate"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <tarihim
                    :etiket="'Dogum Tarihi'"
                    :aktifmi="isUpdate"
                    v-model="paxs.BirthDate"
                    :detaygizle="false"
                    :rules="[(v) => !!v || $t('Please-select-a-date')]"
                  ></tarihim>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <phoneinput v-model="paxs.Phone" :rules="[rules.required]" @change="changePhone(paxs.Phone)" :disabled="isUpdate" />
                  <!-- <v-text-field
                    :label="$t('Telephone')"
                    :disabled="isUpdate"
                    v-model="paxs.Phone"
                    @change="changePhone(paxs.Phone)"
                    :rules="[rules.required]"
                     mask="(###) ###-####"
                  ></v-text-field> -->
                </v-flex>
               
                <v-flex xs12 sm3 md3 v-if="isInternational==false && paxs.Nationality=='TR' ">
                  <v-text-field
                    :label="$t('T-C-Identity-Number')"
                    :disabled="isUpdate"
                    v-model="paxs.CitizenNo"
                    :rules="[rules.required,rules.exactLength11]"
                    mask="###########"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm3 md3>
                  <v-autocomplete
                    :label="$t('Wheelchair')"
                    :items="WheelChairItems"
                    item-text="text"
                    item-value="value"
                    v-model="paxs.WheelChairService"
                    :disabled="isUpdate"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <tarihim
                    :etiket="$t('Passport-Expiry-Date-v2')"
                    :aktifmi="isUpdate"
                    v-model="paxs.PassportExpireDate"
                    :detaygizle="false"
                    :rules="isInternational ? [rules.required] : []"
                  ></tarihim>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    :label="$t('Passport-Number')"
                    hint="Yurtdisi ucuslar ve yabanci yolcular icin girilmelidir"
                    v-model="paxs.PassportNo"
                    
                    :disabled="isUpdate"
                     :rules="isInternational ? [rules.required] : []"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm4 md6 xl3>
                  <v-text-field
                    :label="$t('Mile-Card')"
                    hint="Miles & Miles"
                    v-model="paxs.FrequentFlayerNo"
                    :disabled="isUpdate"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md6 xl3>
                  <v-text-field
                    :label="$t('HES-Code')"
                    v-model="paxs.HesCode"
                    :disabled="isUpdate"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card>

            <!-- Iletisim Bilgileri -->

            <v-card class="pa-2 mb-2">
              <v-layout class="project overdue" row wrap>
                <v-flex xs12 pb-2 sm12 md12>
                  <v-layout row wrap>
                    <v-toolbar flat="" size="120px" dark color="white">
                      <v-toolbar-title>
                        <span class="header black--text">
                          Iletisim Bilgileri
                        </span>
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    :label="$t('Name_label')"
                    :disabled="isUpdate"
                    v-model="updatePassengerItem.Contact.Name"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    :label="$t('Surname_label')"
                    :disabled="isUpdate"
                    v-model="updatePassengerItem.Contact.LastName"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3>
                 
                  <v-text-field
                    :label="$t('Telephone')"
                    :disabled="isUpdate"
                    v-model="updatePassengerItem.Contact.Phone"
                    :rules="[rules.required]"
                    
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    :label="$t('Email_label')"
                    :disabled="isUpdate"
                    v-model="updatePassengerItem.Contact.Email"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card>
            <!-- Fatura Bilgileri -->

            <v-card class="pa-2 mb-2">
              <v-layout class="project overdue" row wrap>
                <v-flex xs12 pb-2 sm12 md6>
                  <v-layout row wrap>
                    <v-toolbar flat="" size="120px" dark color="white">
                      <v-toolbar-title>
                        <span class="header black--text">
                          {{ $t("Invoice-Details") }}
                        </span>
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12 pl-2>
                  <caricomp
                    v-model="cariItem"
                    v-bind:zorunlumu="true"
                    :aktifmi="isUpdate"
                  ></caricomp>
                </v-flex>
              </v-layout>
            </v-card>

            <!-- Not Bilgileri -->

            <v-card class="pa-2">
              <v-layout class="project overdue" row wrap>
                <v-flex xs12 pb-2 sm12 md6>
                  <v-layout row wrap>
                    <v-toolbar flat="" size="120px" dark color="white">
                      <v-toolbar-title>
                        <span class="header black--text">
                          {{ $t("Note") }}
                        </span>
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12 pr-2 pt-2>
                  <v-textarea
                    :label="$t('Reservation-Note')"
                    :hint="
                      $t('Not-sent-entered-airline-showed-for-corporation')
                    "
                    v-model="updatePassengerItem.Notes"
                    outline
                    :disabled="isUpdate"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>

     <!--BİLET DETAY FLEX-->     
<v-flex xs12 sm4 md4 v-if="ticketAllocateReady">
              <v-layout class="project overdue" row wrap>
                <v-flex xs12 pb-2 sm12 md12>
                  <v-layout row wrap>
                    <v-toolbar flat="" size="120px" dark color="white">
                      <v-toolbar-title>
                       
                       <span class="header black--text">
                        {{ $t("Flight-Details-v2") }} 
                        </span>
                          
                        
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                       <span class="header black--text" v-if="PnrNo!=''">
                         <span class=" font-weight-medium grey--text body-2"
                              style="color: #67768f">{{  "PNR:" }} {{ PnrNo}}</span> 
                        </span>
                    </v-toolbar>
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-layout row wrap v-for="(item, i) in ticketAllocate" :key="i"> <!--BİLET kartları başla-->
                 <!-- AKTARMALI TEK YON -->
                  
 <v-card
                class="my-2 elevation-4 w-100" style="width:100%"
                v-if="item.FlightSegments.length == 2"
              >
                <v-layout row wrap>
                 
                  <v-flex xs12 sm4 md2 class="my-auto">
                    <v-img
                      :src="getImgUrl(item.FlightSegments[0].OperatingAirline)"
                      alt="K"
                      height="35px"
                      width="85px"
                      contain
                    >
                    </v-img>
                  </v-flex>
                  <v-flex xs12 sm4 md5>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title
                          >{{
                            item.FlightSegments[0].DepartureDate.substring(
                              0,
                              10
                            )
                          }}
                          {{
                            item.FlightSegments[0].DepartureTime
                          }}</v-list-tile-title
                        >
                        <v-list-tile-sub-title
                          >{{ item.FlightSegments[0].DepartureAirportName }} ({{
                            item.FlightSegments[0].DepartureAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>

                  <v-flex xs12 sm4 md5>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title
                          >{{
                            item.FlightSegments[0].ArrivalDate.substring(0, 10)
                          }}
                          {{
                            item.FlightSegments[0].ArrivalTime
                          }}</v-list-tile-title
                        >
                        <v-list-tile-sub-title>
                          {{ item.FlightSegments[0].ArrivalAirportName }} ({{
                            item.FlightSegments[0].ArrivalAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>
                </v-layout>

                <v-divider></v-divider>
                <v-layout row wrap>
                  <v-flex xs12 sm4 md2 class="my-auto">
                    <v-img
                      :src="getImgUrl(item.FlightSegments[1].OperatingAirline)"
                      alt="K"
                      height="35px"
                      width="85px"
                      contain
                    >
                    </v-img>
                  </v-flex>
                  <v-flex xs12 sm4 md5>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title>{{
                          item.FlightSegments[1].DepartureTime
                        }}</v-list-tile-title>
                        <v-list-tile-sub-title
                          >{{ item.FlightSegments[1].DepartureAirportName }} ({{
                            item.FlightSegments[1].DepartureAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>

                  <v-flex xs12 sm4 md5>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title>{{
                          item.FlightSegments[1].ArrivalTime
                        }}</v-list-tile-title>
                        <v-list-tile-sub-title>
                          {{ item.FlightSegments[1].ArrivalAirportName }} ({{
                            item.FlightSegments[1].ArrivalAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>
                </v-layout>
              </v-card>
                  

                  
<!-- AKTARMALI GIDIS DONUS -->
              <v-card
                class="my-2 elevation-4" style="width:100%"
                v-if="item.FlightSegments.length == 4"
              >
                <v-layout row wrap>
                  <v-flex xs12 sm4 md2 class="my-auto">
                    <v-img
                      :src="getImgUrl(item.FlightSegments[0].OperatingAirline)"
                      alt="K"
                      height="35px"
                      width="85px"
                      contain
                    >
                    </v-img>
                  </v-flex>
                  <v-flex xs12 sm4 md5>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title
                          >{{
                            item.FlightSegments[0].DepartureDate.substring(
                              0,
                              10
                            )
                          }}
                          {{
                            item.FlightSegments[0].DepartureTime
                          }}</v-list-tile-title
                        >
                        <v-list-tile-sub-title
                          >{{ item.FlightSegments[0].DepartureAirportName }} ({{
                            item.FlightSegments[0].DepartureAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>

                  <v-flex xs12 sm4 md5>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title
                          >{{
                            item.FlightSegments[0].ArrivalDate.substring(0, 10)
                          }}
                          {{
                            item.FlightSegments[1].ArrivalTime
                          }}</v-list-tile-title
                        >
                        <v-list-tile-sub-title>
                          {{ item.FlightSegments[1].ArrivalAirportName }} ({{
                            item.FlightSegments[1].ArrivalAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-layout row wrap>
                  <v-flex xs12 sm4 md2 class="my-auto">
                    <v-img
                      :src="
                        getImgUrl(
                          item.FlightSegments[item.FlightSegments.length - 1]
                            .OperatingAirline
                        )
                      "
                      alt="K"
                      height="35px"
                      width="85px"
                      contain
                    >
                    </v-img>
                  </v-flex>
                  <v-flex xs12 sm4 md5>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title>{{
                          item.FlightSegments[2].DepartureTime
                        }}</v-list-tile-title>
                        <v-list-tile-sub-title
                          >{{ item.FlightSegments[2].DepartureAirportName }} ({{
                            item.FlightSegments[2].DepartureAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>
                  <v-flex xs12 sm4 md5>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title>{{
                          item.FlightSegments[3].ArrivalTime
                        }}</v-list-tile-title>
                        <v-list-tile-sub-title>
                          {{ item.FlightSegments[3].ArrivalAirportName }} ({{
                            item.FlightSegments[3].ArrivalAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>
                </v-layout>
              </v-card>
                
             
<!-- AKTARMASIZ TEK YON GIDIS -->
              <v-card
                class="my-2 elevation-4" style="width:100%"
                v-if="item.FlightSegments.length == 1"
              >
                <v-layout row wrap>
                
                  <v-flex xs12 sm4 md2 class="my-auto">
                    <v-img
                      :src="getImgUrl(item.FlightSegments[0].OperatingAirline)"
                      alt="K"
                      height="35px"
                      width="85px"
                      contain
                    >
                    </v-img>
                  </v-flex>
                  <v-flex xs12 sm4 md5>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{
                            item.FlightSegments[0].DepartureDate.substring(
                              0,
                              10
                            )
                          }}
                          {{
                            item.FlightSegments[0].DepartureTime
                          }}</v-list-tile-title
                        >
                        <v-list-tile-sub-title
                          >{{ item.FlightSegments[0].DepartureAirportName }} ({{
                            item.FlightSegments[0].DepartureAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>

                  <v-flex xs12 sm4 md5>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title
                          >{{
                            item.FlightSegments[0].ArrivalDate.substring(0, 10)
                          }}
                          {{
                            item.FlightSegments[0].ArrivalTime
                          }}</v-list-tile-title
                        >
                        <v-list-tile-sub-title>
                          {{ item.FlightSegments[0].ArrivalAirportName }} ({{
                            item.FlightSegments[0].ArrivalAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>
                </v-layout>
              </v-card>
 
  


              </v-layout><!--BİLET kartları SON-->
<v-layout row wrap> <!--TOPLAMLAR-->
<v-layout row wrap>
  <v-flex xs12 sm12 md12>
    <!-- Yolcu kalemleri -->
 <!-- Tüm ticketAllocate elemanları için -->
<div
  v-for="(ticket, tIndex) in ticketAllocate"
  :key="'ticket-' + tIndex"
  class="mb-4"
>
  <!-- Bilet başlık kartı -->
  <!-- <v-card class="pa-2 mb-2 elevation-1" color="#f5f7fa">
    <v-layout row wrap align-center>
      <v-flex xs12>
       <div class="subtitle-2 font-weight-medium" style="color:#4a5872">
  📘 {{ $t("Ticket") }} {{ tIndex + 1 }} {{ '(' }}
  {{ formatTicketNumber(ticket) }} {{ ')' }}
</div>
      </v-flex>
    </v-layout>
  </v-card> -->
<v-card class="pa-2 mb-2 elevation-1" color="#f5f7fa">
  <v-layout row wrap align-center>
    
   
    <v-flex xs8>
      <div class="subtitle-2 font-weight-medium" style="color:#4a5872">
        📘 {{ $t("Ticket") }} {{ tIndex + 1 }} ( {{ formatTicketNumber(ticket) }} )
      </div>
    </v-flex>

   
    <v-flex xs4 class="text-xs-right">
      <v-btn
        small
        color="red darken-1"
        dark
        @click="downloadPdf(ticket)"
        v-if="IsBooking"
      >
        <v-icon left>picture_as_pdf</v-icon>
        PDF
      </v-btn>
       
    </v-flex>

  </v-layout>
</v-card>
  <!-- Yolcu kalemleri (her bilet için) -->
  <v-card
    v-for="(paxDetails, d) in ticket.PassengerBreakdowns"
    :key="'pax-' + tIndex + '-' + d"
    class="pb-2"
    flat
  >
    <v-hover>
      <template slot-scope="{ hover }">
        <v-card
          width="100%"
          :class="`elevation-${hover ? 12 : 2}`"
          class="elevation-1 pt-3 pl-3 pb-3"
        >
          <v-layout row wrap align-center justify-end>
            <!-- 1. Kolon -->
            <v-flex xs12 sm6 md4>
              <v-flex
                xs12
                sm12
                md12
                class="font-weight-medium grey--text body-2"
                style="color: #67768f"
              >
                <span style="color: #67768f">
                  {{ d + 1 }} .
                  {{ paxDetails.PaxReference.PaxCode | passengerType }}
                  {{ $t("Passenger") }} :
                </span>
              </v-flex>

              <v-flex
                xs12
                sm12
                md12
                class="font-weight-medium grey--text caption"
                style="color: #67768f"
              >
                <span style="color: #67768f">{{ $t("Net") }} :</span>
                {{ paxDetails.BaseFare }}
              </v-flex>

              <v-flex
                xs12
                sm12
                md12
                class="font-weight-medium grey--text caption"
                style="color: #67768f"
              >
                <span style="color: #67768f">{{ $t("Tax-v2") }} :</span>
                {{ paxDetails.TotalTax }}
              </v-flex>
            </v-flex>

            <!-- 2. Kolon -->
            <v-flex xs12 sm6 md4>
              <v-flex
                xs12
                sm12
                md12
                class="font-weight-medium grey--text caption"
                style="color: #67768f"
              >
                <span style="color: #67768f">{{ $t("Service") }} :</span>
                {{ paxDetails.TotalServiceFee }}
              </v-flex>

              <v-flex
                xs12
                sm12
                md12
                class="font-weight-medium grey--text caption"
                style="color: #67768f"
              >
                <span style="color: #67768f">{{ $t("Maturity") }}:</span>
                {{ paxDetails.TotalLateInterest }}
              </v-flex>

              <v-flex
                xs12
                sm12
                md12
                class="font-weight-medium grey--text caption"
                style="color: #67768f"
              >
                <span style="color: #67768f">{{ $t("Markup") }} :</span>
                {{ paxDetails.TotalMarkupFare }}
              </v-flex>
            </v-flex>

            <!-- 3. Kolon -->
            <v-flex xs12 sm6 md4>
              <v-flex
                xs12
                sm12
                md12
                class="font-weight-medium grey--text caption"
                style="color: #67768f"
              >
                <span style="color: #67768f">L.Markup:</span>
                {{ paxDetails.TotalMarkupFareList }}
              </v-flex>

              <v-flex
                xs12
                sm12
                md12
                class="font-weight-medium grey--text caption"
                style="color: #67768f"
              >
                <span style="color: #67768f">{{ $t("Total") }}:</span>
                {{ paxDetails.TotalFare }}
              </v-flex>

              <v-flex
                xs12
                sm12
                md12
                class="font-weight-medium grey--text caption"
                style="color: #67768f"
              >
                <span style="color: #67768f">
                  {{ $t("Currency-Unit") }} :
                </span>
                {{ paxDetails.Currency }}
              </v-flex>
            </v-flex>
          </v-layout>
        </v-card>
      </template>
    </v-hover>
  </v-card>
</div>

    <!-- Toplamlar kartı -->
    <v-card class="my-2 elevation-2 pa-2">
      <v-layout row wrap align-center justify-end>
        <v-flex xs12 sm6 md4>
          <v-flex
            xs12
            sm12
            md12
            class="font-weight-medium grey--text body-2"
            style="color: #67768f"
          >
            <span style="color: #67768f">
              {{ $t("Totals") }} :
            </span>
          </v-flex>

          <v-flex
            xs12
            sm12
            md12
            class="font-weight-medium grey--text caption"
            style="color: #67768f"
          >
            <span style="color: #67768f">Toplam Net:</span>
            {{ footerBaseFare }}
          </v-flex>

          <v-flex
            xs12
            sm12
            md12
            class="font-weight-medium grey--text caption"
            style="color: #67768f"
          >
            <span style="color: #67768f">Toplam Vergi:</span>
            {{ footerTotalTax }}
          </v-flex>
        </v-flex>

        <v-flex xs12 sm6 md4>
          <v-flex
            xs12
            sm12
            md12
            class="font-weight-medium grey--text caption"
            style="color: #67768f"
          >
            <span style="color: #67768f">Toplam Servis :</span>
            {{ footerTotalServiceFee }}
          </v-flex>

          <v-flex
            xs12
            sm12
            md12
            class="font-weight-medium grey--text caption"
            style="color: #67768f"
          >
            <span style="color: #67768f">Toplam Vade:</span>
            {{ footerLateInterest }}
          </v-flex>

          <v-flex
            xs12
            sm12
            md12
            class="font-weight-medium grey--text caption"
            style="color: #67768f"
          >
            <span style="color: #67768f">Toplam Markup:</span>
            {{ footerTotalMarkupFare }}
          </v-flex>
        </v-flex>

        <v-flex xs12 sm6 md4>
          <v-flex
            xs12
            sm12
            md12
            class="font-weight-medium grey--text caption"
            style="color: #67768f"
          >
            <span style="color: #67768f">
              Toplam L.Markup :
            </span>
            {{ footerTotalMarkupFareList }}
          </v-flex>

          <v-flex
            xs12
            sm12
            md12
            class="font-weight-medium grey--text caption"
            style="color: #67768f"
          >
            <span style="color: #67768f">Toplam Tutar:</span>
            {{ footerTotalFare }}
          </v-flex>
        </v-flex>
      </v-layout>
    </v-card>

    <!-- Provider kartı -->
   

    <!-- Eski data-table (istersen açarsın)
    <v-data-table
      :headers="headersSummary"
      :items="item.PassengerBreakdowns"
      hide-actions
      class="elevation-1"
      item-key="id"
      style="max-width: 500px"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">
          {{ props.item.PaxReference.PaxCode }}
        </td>
        <td class="text-xs-left">{{ props.item.BaseFare }}</td>
        <td class="text-xs-left">
          {{ props.item.TotalTax }}
        </td>
        <td class="text-xs-left">
          {{ props.item.TotalServiceFee }}
        </td>
        <td class="text-xs-left">
          {{ props.item.TotalLateInterest }}
        </td>
        <td class="text-xs-left">
          {{ props.item.TotalMarkupFare }}
        </td>
        <td class="text-xs-left">
          {{ props.item.TotalMarkupFareList }}
        </td>
        <td class="text-xs-left">
          {{ props.item.TotalFare }}
        </td>
        <td class="text-xs-left">{{ props.item.Currency }}</td>
      </template>

      <template slot="footer">
        <td>
          <strong> {{ $t('Totals') }} </strong>
        </td>
        <td>
          <strong>{{ footerBaseFare }}</strong>
        </td>
        <td>
          <strong> {{ footerTotalTax }} </strong>
        </td>
        <td>
          <strong> {{ footerTotalServiceFee }} </strong>
        </td>
        <td>
          <strong> {{ footerLateInterest }} </strong>
        </td>
        <td>
          <strong> {{ footerTotalMarkupFare }} </strong>
        </td>
        <td>
          <strong> {{ footerTotalMarkupFareList }} </strong>
        </td>
        <td>
          <strong> {{ footerTotalFare }} </strong>
        </td>
        <td>
          <strong>&nbsp; </strong>
        </td>
      </template>
    </v-data-table>
    -->
  </v-flex>
</v-layout>

<!-- Promosyon / Esnek bilet chipleri -->
<v-layout row wrap pt-2 v-if="ticketAllocate && ticketAllocate.length && ticketAllocate[0].FlightSegments && ticketAllocate[0].FlightSegments.length">
  <v-flex
    xs12
    sm12
    md12
    v-if="
      ticketAllocate[0].FlightSegments[0].FareCode != null &&
      ticketAllocate[0].FlightSegments[0].FareCode == 'Promo'
    "
  >
    <v-chip outline color="primary" text-color="primary">
      <v-icon color="primary" left>flight</v-icon>
      {{ ticketAllocate[0].Provider }} {{ $t("Promotion") }}
    </v-chip>
    <v-chip label color="primary" text-color="primary">
      <v-icon color="primary" left>info</v-icon>
      {{
        $t("Cancellation-returns-not-available-promotion-tickets")
      }}
    </v-chip>
  </v-flex>

  <v-flex xs12 sm12 md12 v-else>
    <v-chip outline color="primary" text-color="primary">
      <v-icon color="primary" left>flight</v-icon>
      {{ ticketAllocate[0].Provider }} {{ $t("Flexible") }}
    </v-chip>
    <v-chip outline color="primary" text-color="primary">
      <v-icon color="primary" left>info</v-icon>
      {{
        $t(
          "Cancellation-changes-returns-flexible-tickets-subject-certain-rules"
        )
      }}
    </v-chip>
  </v-flex>
</v-layout>



<!-- Segmentler (şu an yorumlu içerik) -->
<v-flex
  xs12
  sm12
  md12
  v-if="!isUpdate && ticketAllocate && ticketAllocate.length && ticketAllocate[0].FlightSegments"
  v-for="(itemSegment, indexSeg) in ticketAllocate[0].FlightSegments"
  :key="indexSeg"
>
  <!--
  <v-flex
    v-if="!itemSegment.PricingInfo!=null"
    v-for="(itemPricingInfo, indexPrice) in itemSegment.PricingInfo.FareBreakdowns"
    :key="indexPrice"
  >
    <v-flex
      v-for="(itemAmenities, indexAmen) in itemPricingInfo.Amenities"
      :key="indexAmen"
      xs12
      sm12
      md12
    >
      <v-chip outline color="green">
        <v-icon color="green" left>luggage</v-icon>
        {{ itemAmenities.Description }}
      </v-chip>
    </v-flex>
  </v-flex>
  -->
</v-flex>


</v-layout><!--TOPLAMLAR SON-->

<!--İŞLEMLER-->
 <v-layout row wrap v-if="!isUpdate">
                <v-flex v-if="!IsBooking" xs12 sm6 md12 pl-2>
                  <v-btn color="primary" @click="updatePassenger(1)" block>
                    <v-icon left>book_online</v-icon>
                    {{ $t("Make-a-Reservation") }}
                  </v-btn>
                </v-flex>
                <v-flex v-if="!IsBooking" xs12 sm6 md12 pl-2>
                  <v-btn color="success" @click="updatePassenger(2)" block>
                    <v-icon left>add_shopping_cart</v-icon>
                    {{ "Bileti Kes - Cari Ödeme" }}
                  </v-btn>
                </v-flex>
                  <v-flex v-if="!IsBooking && (Provider=='Turna' || Provider=='BiletBank' || Provider=='Amadeus')" xs12 sm6 md12 pl-2>
                  <v-btn color="success" @click="updatePassengerCard(2,'update')" block>
                    <v-icon left>credit_card</v-icon>
                    {{ "Bileti Kes - Kredi Kartı" }}
                  </v-btn>
                </v-flex>
                 <v-flex  xs12 sm6 md12 pl-2>
                  <v-btn  color="" @click="$router.go(-1)" block>
                    
                    <v-icon left>arrow_back</v-icon>
                    {{ "Geri Dön" }}
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="isUpdate">
                <v-flex v-if="!IsBooking" xs12 sm6 md12 pl-2>
                  <v-btn
                    color="red lighten-1"
                    :disabled="!IsCancelable"
                    @click="cancelReservation()"
                    block
                  >
                    <v-icon left>cancel</v-icon>
                    {{ $t("Cancel-Reservation-v2") }}
                  </v-btn>
                </v-flex>
                <v-flex v-if="!IsBooking" xs12 sm6 md12 pl-2>
                  <v-btn color="success" @click="makePayment()" block>
                    <v-icon left>add_shopping_cart</v-icon>
                    {{ "Bileti Kes" }}
                  </v-btn>
                </v-flex>
                  <v-flex  v-if="!IsBooking && (Provider=='Turna' || Provider=='BiletBank' || Provider=='Amadeus')" xs12 sm6 md12 pl-2>
                  <v-btn  color="success" @click="updatePassengerCard(2,'payment')" block>
                    <v-icon left>credit_card</v-icon>
                    {{ "Bileti Kes - Kredi Kartı" }}
                  </v-btn>
                </v-flex>
                  <v-flex  v-if="IsBooking && !nextStatu" xs12 sm6 md12 pl-2>
                  <v-btn  color="info" @click="sendNextTicket(ShoppingCard)" block>
                    <v-icon left>edit</v-icon>
                    {{ "Arkmana İşle" }}
                  </v-btn>
                </v-flex> 
                 <v-flex  v-if="IsBooking && nextStatu" xs12 sm6 md12 pl-2>
                  <v-btn  color="info" @click="goNextTicket(ShoppingCard)" block>
                    <v-icon left>search</v-icon>
                    {{ "Arkmanda Göster" }}
                  </v-btn>
                </v-flex> 
                 <v-flex  xs12 sm6 md12 pl-2>
                  <v-btn  color="" @click="$router.go(-1)" block>
                    <v-icon left>arrow_back</v-icon>
                    {{ "Geri Dön" }}
                  </v-btn>
                </v-flex>
                
              </v-layout>


<!--İŞLEMLER SON-->


</v-flex> <!--BİLET DETAY SON-->



        </v-layout>



      </v-card>
    </v-form>

    <v-layout row justify-center>
      <v-dialog v-model="dialog" persi persistent max-width="390">
        <v-card>
          <v-card-text
            >Biletiniz oluşturulmuştur. Minumum 5 dakika içinde Next Arkman
            sistemine aktarılacaktır.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
</div>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import phoneinput from "../../customcomp/phoneinput.vue";
import auth from "@/api/auth.js";
import logoo from "@/assets/control.js";
import Airports from "@/components/app/satis/ucak/airports.js";
import caricomp from "@/components/app/customcomp/caricomp.vue";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import helpers from "@/components/app/customcomp/helpers.js";
import doviz from "@/components/app/muhasebe/comp/doviz.vue";
import Phoneinput from "../../customcomp/phoneinput.vue";
import tool from "../../coper/tools";

export default {
  data() {
    return {
      
       nextStatu:false,
       ListInput: {
                    SirketKodu: 1,
                    BaslangicTarihi: null,
                    BitisTarihi: null,
                    Carikod: null,
                    HavaYoluKodu: null,
                    FormNo: null,
                    BiletNo: null,
                    TextSearch: null,
                    Paging: {
                        SayfaNo: null,
                        VeriAdet: 50,
                        SiralamaTip: 0
                    },
                    Filtreler: {
                        CariKod: null,
                        Havayollari: [],
                        Parkurlar: [],
                        HatTipi: [], // I : iç hat, D: Dış hat, B: Bsp
                        BiletTipi: 'S', // S: Satış, I: Iade, V : Void
                        Ucus1: null,
                        Ucus2: null,
                        KesenKisi: null,
                        PosKod: null,
                        DekontBas: false,
                        KrediKartNo: null,
                        GiderPusulasi: 0, // 0: seçim yok, 1 : basılmış, 2 : basılmamış
                        AcentaFatNo: 0, // 0 : seçim yok, 1 : fatura olan, 2 : fatura olmayan
                        IadeFatura: false,
                        SifirTutarGosterme:false,
                        RezVerenBosGoster:false,
                        GeciciCari: 0, // 0 : hepsi, 1 : geci haric, 2 : sadece gecici
                        FaturaStatus: 0, // 0 : hepsi, 1 : faturalanmamışlar, 2 : faturalanmışlar
                        BaslangicTutar: 0,
                        BitisTutar: 0,
                        YolcuAdi:null,
                        PnrNo:null,
                        TutarTip: 0, // 0 : NetTutar, 1 : Bilet Tutar, 2 : Servis Tutar, 3 : Iskonto Tutar
                        BiletAcenteTipi:0, // 0: hepsi  1: Acente  2: Direkt kesilenler
                    }
                },
      threedConfirmDialog:false,
    pdfactive:false,
     Adres: {
          CreatedBy: null,
          CreatedDate: null,
          ModifiedBy: null,
          ModifiedDate: null,
          PspOfsTeslimAlan: null,
          PspOfsTeslimTarihi: null,
          PspMusTeslimEden: null,
          PspMusTeslimTarihi: null,
          dptBolge: {
            id: null,
            kod: null,
            isim: null,
            tip: null,
          },
          dptYonetim: {
            id: null,
            kod: null,
            isim: null,
            tip: null,
          },
          dptDepartman: {
            id: null,
            kod: null,
            isim: null,
            tip: null,
          },
          dptAltDepartman: {
            id: null,
            kod: null,
            isim: null,
            tip: null,
          },
          dptBolum: {
            id: null,
            kod: null,
            isim: null,
            tip: null,
          },
          dptCariKod: {
            id: null,
            kod: null,
            isim: null,
            tip: null,
          },
          SicilID: null,
          Id: 0,
          Kategori: null,
          Ad: null,
          Soyad: null,
          Adres: null,
          DogumTarihi: null,
          Ulke: null,
          Sehir: null,
          Meslek: null,
          Telefon1: null,
          Telefon2: null,
          GSM: null,
          Email: null,
          PasaportTip: 0,
          PasaportNo: null,
          VerildigiYer: null,
          VerilisTarihi: null,
          BitisTarihi: null,
          Sigara: null,
          Notlar: null,
          USAVize: null,
          USABitis: null,
          AnneAdi: null,
          BabaAdi: null,
          TCKimlikNo: null,
          DogumYeri: null,
          Kod: 0,
          Cinsiyet: 0,
          RezIstekleri: null,
          SirketNo: null,
          UyeNo: null,
          PspCocukVar: false,
          PspCocukVizeIstiyor: false,
          Cocuk1Kod: null,
          OnlineCIn: false,
          OzelGun1: null,
          OzelGun2: null,
          OzelGun3: null,
          OzelGun4: null,
          OzelGun5: null,
          EskiYeni: null,
          Uyruk: null
        },
       ListInput: {
                    SirketKodu: null,
                    BaslangicTarihi: null,
                    BitisTarihi: null,
                    Carikod: null,
                    HavaYoluKodu: null,
                    FormNo: null,
                    BiletNo: null,
                    TextSearch: null,
                    Paging: {
                        SayfaNo: null,
                        VeriAdet: 50,
                        SiralamaTip: 0
                    },
                    Filtreler: {
                        CariKod: null,
                        Havayollari: [],
                        Parkurlar: [],
                        HatTipi: [], // I : iç hat, D: Dış hat, B: Bsp
                        BiletTipi: 'S', // S: Satış, I: Iade, V : Void
                        Ucus1: null,
                        Ucus2: null,
                        KesenKisi: null,
                        PosKod: null,
                        DekontBas: false,
                        KrediKartNo: null,
                        GiderPusulasi: 0, // 0: seçim yok, 1 : basılmış, 2 : basılmamış
                        AcentaFatNo: 0, // 0 : seçim yok, 1 : fatura olan, 2 : fatura olmayan
                        IadeFatura: false,
                        SifirTutarGosterme:false,
                        RezVerenBosGoster:false,
                        GeciciCari: 0, // 0 : hepsi, 1 : geci haric, 2 : sadece gecici
                        FaturaStatus: 0, // 0 : hepsi, 1 : faturalanmamışlar, 2 : faturalanmışlar
                        BaslangicTutar: 0,
                        BitisTutar: 0,
                        YolcuAdi:null,
                        PnrNo:null,
                        TutarTip: 0, // 0 : NetTutar, 1 : Bilet Tutar, 2 : Servis Tutar, 3 : Iskonto Tutar
                        BiletAcenteTipi:0, // 0: hepsi  1: Acente  2: Direkt kesilenler
                    }
                },
      isInternational:false,
      prmAcenteKodu:'',
    itemsproviders:[],
    ShoppingCard2:null,
      IsBooking:false,
      validOdeme:true,
      cardval:0,
      cardmethod:'payment',
        sonkullanimAy: [{
                    id: '01',
                    text: '1'
                },
                {
                    id: '02',
                    text: '2'
                },
                {
                    id: '03',
                    text: '3'
                },
                {
                    id: '04',
                    text: '4'
                },
                {
                    id: '05',
                    text: '5'
                },
                {
                    id: '06',
                    text: '6'
                },
                {
                    id: '07',
                    text: '7'
                },
                {
                    id: '08',
                    text: '8'
                },
                {
                    id: '09',
                    text: '9'
                },
                {
                    id: '10',
                    text: '10'
                },
                {
                    id: '11',
                    text: '11'
                },
                {
                    id: '12',
                    text: '12'
                }
            ],
            sonkullanimYil: [
                '2025', '2026', '2027', '2028',
                '2029', '2030' ,'2031','2032','2033','2034','2035'
            ],
      creditCardInfo:false,
        PaymentForm: {
        CardHolder: null,
        CardNumber: null,
        CardType: "Visa",
        Cvv: null,
        ExpirationYear: null,
        ExpirationMonth: null,
        ExtraAmount: 0,
        InstallmentId: null,
        InstallmentCount: 1,
        Currency: "TRY",
        ReturnUrl: "http://address.com/Finalize?ShopCartId=2eec463b-1d2b-4dbf-9275-4d36af90d45a"
            },
      grandtotalAlert:false,
      grandTotal:0,
      rules: {
        exactLength11: value => value.length === 11 || 'TCK 11 Karakter Olmalıdır',
        required: (value) => !!value || this.$t("Mandatory-Areas"),
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t("Wrong-e-mail");
        },
      },
      dialog: false,
      valid: true,
      cariItem: null,
      billingInformationItem: Airports.billingInformation(),
      makePrebookingItem: Airports.makePrebooking(),
      finalizeShoppingItem: Airports.finalizeShopping(),
      updatePassengerItem: Airports.updatePassengers(),
      WheelChairItems: Airports.wheelChairs(),
      countryItems: Airports.countiries(),
      genderItems: Airports.Genders(),
      headersSummary: Airports.headersFlightInfoSummary(),
      makePaymentItem: Airports.makePayment(),
      nextTicket: Airports.nextTicket(),
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: true,
      ticketAllocate: [],
      passengerList: [],
      paxList: [],
      footerBaseFare: 0,
      footerTotalTax: 0,
      footerTotalServiceFee: 0,
      footerLateInterest: 0,
      footerTotalMarkupFare: 0,
      footerTotalMarkupFareList: 0,
      footerTotalFare: 0,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      PnrNo:'',
      Provider:'',
      flightType: null,
      CurrentCode: null,
      isContactDefault: -1,
      defaultContactValue: false,
      contactValueList: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
      currencyValue: 0,
      isUpdate: false,
      IsCancelable: false,
      syncFirstName: null,
    };
  },
  computed: {
  ticketAllocateReady() {
    return (
      Array.isArray(this.ticketAllocate) &&
      this.ticketAllocate.length > 0 &&
      this.ticketAllocate[0] &&
      Array.isArray(this.ticketAllocate[0].FlightSegments)
    );
  }
},
  methods: {
    searchTicketNo(){
              
                 let credentials = JSON.parse(window.localStorage.getItem('credentials'));
                this.ListInput.BiletNo =this.ticketAllocate[0].PassengerBreakdowns[0].TicketNumber.substring(3);
                this.ListInput.BaslangicTarihi = this.ticketAllocate[0].FlightSegments[0].DepartureDate;
                this.ListInput.BitisTarihi =  this.ticketAllocate[0].FlightSegments[0].DepartureDate;
                 this.ListInput.SirketKodu =  credentials.SirketKodu.toString();
                 this.ListInput.Paging.SayfaNo=1;
                this.$http.post(auth.API_URL + 'api/Ticket/TicketList', this.ListInput, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    if (response.body.length == 1) {
                       
                      this.nextStatu=true;
                        
                        // if (response.body[0].GenelBilgileri.Status == 'S' || response.body[0].GenelBilgileri.Status == 'Ia') {
                        //     let url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + response.body[0].GenelBilgileri.HavaYoluKodu + '&biletno=' + response.body[0]
                        //         .GenelBilgileri
                        //         .BiletNo + '&ucustipi=' + response.body[0].GenelBilgileri.UcusTipi
                        //     window.open(url, '_blank')
                        // } else if (response.body[0].GenelBilgileri.Status == 'V') {
                        //     let url = '#/bilet/yeni/id?' + 'isl=voidget&hyolukod=' + response.body[0].GenelBilgileri.HavaYoluKodu + '&biletno=' + response.body[0]
                        //         .GenelBilgileri
                        //         .BiletNo + '&ucustipi=' + response.body[0].GenelBilgileri.UcusTipi
                        //     window.open(url, '_blank')
                        // }
    
    
                    }else if(response.body.length > 1){
                       
    
                    } else {
                       this.nextStatu=false;
                    }
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                        this.loadingdialog = false;
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                        this.loadingdialog = false;
                    }
                })
            },
     async imageUrlToBase64(url) {
  const response = await fetch(url);
  const blob = await response.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
},
    confirmthereed(){
this.threedConfirmDialog=true;
    },
    downloadPdf() {
   this.pdfactive=true;
   this.sendNextTicket(this.ShoppingCard);
  },
    formatTicketNumber(ticket) {

    if (!ticket ||
        !ticket.PassengerBreakdowns ||
        !ticket.PassengerBreakdowns.length ||
        !ticket.PassengerBreakdowns[0].TicketNumber) {
      return '';
    }

    var number = ticket.PassengerBreakdowns[0].TicketNumber;

    if (number.length <= 3) return number;

    return number.substring(0, 3) + '-' + number.substring(3);
  },


   getProviders()
    {
      this.prmAcenteKodu=null;
       var bookingParams = JSON.parse(
        window.localStorage.getItem("bookingParams")
      );
      this.itemsproviders=[];
 var params = {
  SessionHeader: {
    SessionId: bookingParams.SessionId, 
    SessionToken: bookingParams.SessionToken    }
      }
       this.$http
        .post(auth.BOOKING_API_URL + "Agency/GetCredential", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
          console.log(response.body);
            var rsp=response.body.Credentials;
           rsp.forEach(element => {
            if (element.ProviderType=='Air' && element.Provider=="Turna")
           {
            this.prmAcenteKodu=element.OfficeId;
 var prv={
      Id:element.Id,
      Provider:element.Provider,
      ProviderType:element.ProviderType,
      ServiceUsername:element.ServiceUsername,
      ServicePassword:element.ServicePassword,
      ServiceSecurityKey:element.ServiceSecurityKey,
      OfficeId:element.OfficeId,
      url:element.Address
    }
    this.itemsproviders.push(prv);
           }
   
});

console.log(this.itemsproviders);
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "GetCredential - Service Unavailable";
              this.snackbar = true;
            } else {
              this.text1 = "GetCredential - Service Unavailable";
              this.snackbar = true;
            }
          }
        );
    },
  creditCardPayment()
  {
   this.threedConfirmDialog=false;
   
     if (this.$refs.formodeme.validate()) {

  this.creditCardInfo=false;
  this.makePaymentItem.PaymentType="CreditCardPayment";
  this.makePaymentItem.PayableBank="5";
  if (this.cardmethod=='update')
  {
    this.updatePassenger(this.cardval);
  }
  else
  {
    this.makePayment();
  }
     }
  
  },

  updatePassengerCard(val,val2)
  {
    
     if (this.Provider=="Turna"){
     
        if (this.prmAcenteKodu=='' || this.prmAcenteKodu==null){
          alert('Turna Acente Kodu Bulunamadı..');
          return;
        }
      }
     
    this.cardval=val;
    this.cardmethod=val2,
    this.creditCardInfo=true;
  },
    checkPhoneFormat(value){
      let zeroControl = value.substring(0,1);
      
      if(zeroControl == 0){
        return "+90" + value.substring(1);
      }else{
        return "+90" + value;
      }

    },
    changePhone(phone) {
      this.updatePassengerItem.Contact.Phone = phone;
    },
    changeEmail(email) {
      if (this.paxList.length == 1) {
        this.updatePassengerItem.Contact.Email = email;
      }
    },
    changeLastName(lastName) {
      if (this.paxList.length == 1) {
        this.updatePassengerItem.Contact.LastName = lastName;
      }
    },
    changeFirstName(firstName) {
      if (this.paxList.length == 1) {
        this.updatePassengerItem.Contact.Name = firstName;
      }
    },
    cancelReservation() {
      this.loadingvmodel = true;
      var bookingParams = JSON.parse(
        window.localStorage.getItem("bookingParams")
      );
      var params = {
        SessionHeader: {
          SessionId: bookingParams.SessionId,
          SessionToken: bookingParams.SessionToken,
        },
        bookingData: {
          locator: this.$route.query.pnr,
        },
        ShoppingCartId: window.localStorage.getItem("shopCartID"),
      };

      this.$http
        .post(auth.BOOKING_API_URL + "Air/CancelReservation", params)
        .then(
          (response) => {
            if (!response.body.HasError) {
              this.loadingvmodel = false;
              this.text1 = "Rezervasyon iptal edildi";
              this.snackbar = true;

              setTimeout(
                function () {
                  var url1 = "#/satis/ucus/rezervasyonliste";
                  window.open(url1, "_self");
                }.bind(this),
                1250
              );
            } else {
              this.text1 = response.body.ServiceError.ErrorMessages[0];
              this.snackbar = true;
              this.loadingvmodel = false;
              this.snackbarkColor = "warning";
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Air/CancelReservation";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-Air/CancelReservation";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    searchBillingInfo(val) {
      let params = {
        q: val,
        Coper: false,
      };

      this.$http
        .post(auth.API_URL + "api/options/CurrentSearch", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.cariItem = response.body[0].id;
            if (this.$route.query.islem == "new") {
              this.billingSubmit();
            } else {
              this.nextTicket.GenelBilgileri.MusteriKodu.Kod =
                response.body[0].id;
            }
          },
          (response) => {
            if (response.status === 0) {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
            } else {
              this.text1 = response.statusText;
              this.snackbar = true;
            }
          }
        );
    },
    moneyformat(m) {
      if (m != 0) {
        return m.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
      } else {
        return 0;
      }
    },
    defaultContact(contact, index) {
      if (
        this.isContactDefault != index &&
        this.contactValueList[index] != false
      ) {
        this.updatePassengerItem.Contact.Name = contact.FirstName;
        this.updatePassengerItem.Contact.LastName = contact.LastName;
        this.updatePassengerItem.Contact.Phone = contact.Phone;
        this.updatePassengerItem.Contact.Email = contact.Email;
        this.isContactDefault = index;
      } else {
        this.updatePassengerItem.Contact.Name = "";
        this.updatePassengerItem.Contact.LastName = "";
        this.updatePassengerItem.Contact.Phone = "";
        this.updatePassengerItem.Contact.Email = "";
        this.isContactDefault = -1;
      }
    },
   
             maskCardNumber(cardNo) {
  
  const s = String(cardNo).replace(/\D/g, "");
  if (s.length <= 8) return s; 

  return s.slice(0, 4) + "*".repeat(s.length - 8) + s.slice(-4);
},
 goNextTicket(val) {
     
      let ticketno=null;
      this.loadingvmodel = true;
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
       
      
const flight = val.AirBookings[0].FlightSegments[0];

const isDomestic = flight.DepartureCountryName === flight.ArrivalCountryName;


      this.nextTicket.GenelBilgileri.SirketKodu = credentials.SirketKodu;

      val.AirBookings.forEach((element) => {
        for (
          let index = 0;
          index < element.PassengerBreakdowns.length;
          index++
        ) {
          const breakdown = element.PassengerBreakdowns[index];
          var bookingcode=element.BookingCode;  
       
          if (bookingcode==breakdown.TicketNumber){
this.nextTicket.GenelBilgileri.BiletNo="0";
this.nextTicket.otomatikBiletNo=true;
 this.nextTicket.GenelBilgileri.HavaYoluKodu =element.FlightSegments[0].MarkettingAirline;
          }else{
           this.nextTicket.GenelBilgileri.BiletNo =
            breakdown.TicketNumber.substring(3);
            ticketno=breakdown.TicketNumber.substring(3);
           
           this.nextTicket.GenelBilgileri.Formno =
            breakdown.TicketNumber.substring(0, 3);
            this.nextTicket.GenelBilgileri.HavaYoluKodu =
            element.FlightSegments[0].MarkettingAirline;
          }
        

          


          this.nextTicket.GenelBilgileri.Acente = "";
          this.nextTicket.GenelBilgileri.AcenteKodu = "";
          if (this.Provider=="Turna"){
             this.nextTicket.GenelBilgileri.Acente = "A";
             this.nextTicket.GenelBilgileri.AcenteKodu = this.prmAcenteKodu;
          }
          this.nextTicket.GenelBilgileri.ArkmanUsers = "WEB";
          this.nextTicket.GenelBilgileri.Crs = "ArkmanAktarim";

           if (this.makePaymentItem.PaymentType=="CreditCardPayment"){
            this.nextTicket.OdemeBilgileri.SatisSekli="F";
            this.nextTicket.OdemeBilgileri.KomisyonTip="K";
            this.nextTicket.OdemeBilgileri.KrediKartBilgi.KrediKartNo=this.maskCardNumber(this.PaymentForm.CardNumber);
            this.nextTicket.OdemeBilgileri.KrediKartBilgi.KrediKartTip="F";
           }
          
        if (!isDomestic)
        {
 this.nextTicket.GenelBilgileri.UcusTipi = "D";
 this.nextTicket.TanimBilgileri.ServisKod="21";
        }else{
 this.nextTicket.GenelBilgileri.UcusTipi = "I";
 this.nextTicket.TanimBilgileri.ServisKod="11";
        }
          //Sadece dis hatlar mi olacak ?
          if (this.$route.query.islem == "new") {
            this.nextTicket.GenelBilgileri.MusteriKodu.Kod = this.CurrentCode;
          }
          this.nextTicket.GenelBilgileri.MusteriKodu.Unvan =
            val.BillingInformation.BillingName;

          var analysisprice =
            breakdown.TotalMarkupFare + breakdown.TotalMarkupFareList;

          var baseFare = breakdown.BaseFare;
          // var serviceFee =
          //   breakdown.TotalServiceFee +
          //   analysisprice -
          //   passenger.ExtraPosAmount;

          baseFare -= analysisprice;

          // Tutar Bilgileri

          this.nextTicket.TutarBilgileri.NetTutar.NetTutar =
            this.footerTotalFare;
          this.nextTicket.TutarBilgileri.TaxTutar.TaxTutar =
            this.footerTotalTax;
          this.nextTicket.TutarBilgileri.ServisTutar.ServisTutar =
            this.footerTotalMarkupFare;
          this.nextTicket.TutarBilgileri.Tutar.Tutar = this.footerBaseFare;
          this.nextTicket.NotlarBilgileri.RefFare = this.footerBaseFare;
          this.nextTicket.NotlarBilgileri.LowFare =
            this.footerBaseFare - this.footerTotalMarkupFare;
          // this.nextTicket.TutarBilgileri.DigerServisTutar.DigerServisTutar = passenger.ExtraPosAmount;
          this.nextTicket.TutarBilgileri.Kur = val.Currency;

          this.nextTicket.TanimBilgileri.AnalizKod.AnalizTutar = analysisprice;
          this.nextTicket.TanimBilgileri.AnalizKod.AnalizKod = "KOM";

          this.nextTicket.TarihBilgileri.SatisTarihi = helpers.getDateNow();
          this.nextTicket.TarihBilgileri.OdemeTarihi = helpers.getDateNow();

          var destination1 = element.FlightSegments[0].DepartureAirportCode;
          var destination2 = element.FlightSegments[0].ArrivalAirportCode;
          var destination3;
          var destination4;
          var destination5;

          switch (element.FlightSegments.length) {
            case 2:
              destination3 = element.FlightSegments[1].ArrivalAirportCode;
              destination4 = "";
              destination5 = "";
              break;
            case 3:
              destination3 = element.FlightSegments[1].ArrivalAirportCode;
              destination4 = element.FlightSegments[2].ArrivalAirportCode;
              destination5 = "";
              break;
            case 4:
              destination3 = element.FlightSegments[1].ArrivalAirportCode;
              destination4 = element.FlightSegments[1].DepartureAirportCode;
              destination5 = element.FlightSegments[3].ArrivalAirportCode;
              break;
            case 5:
              destination3 = element.FlightSegments[
                element.FlightSegments.length - 1
              ].find((x) => x.DirectionInd == 0).ArrivalAirportCode;
              destination4 = element.FlightSegments[
                element.FlightSegments.length - 1
              ].find((x) => x.DirectionInd == 1).DepartureAirportCode;
              destination5 = element.FlightSegments[
                element.FlightSegments.length - 1
              ].find((x) => x.DirectionInd == 1).ArrivalAirportCode;
              break;
            case 6:
              destination3 = element.FlightSegments[
                element.FlightSegments.length - 1
              ].find((x) => x.DirectionInd == 0).ArrivalAirportCode;
              destination4 = element.FlightSegments[
                element.FlightSegments.length - 1
              ].find((x) => x.DirectionInd == 1).DepartureAirportCode;
              destination5 = element.FlightSegments[
                element.FlightSegments.length - 1
              ].find((x) => x.DirectionInd == 1).ArrivalAirportCode;
              break;
            case 7:
              destination3 = element.FlightSegments[1].DepartureAirportCode;
              destination4 = element.FlightSegments[2].ArrivalAirportCode;
              destination5 = element.FlightSegments[3].ArrivalAirportCode;
              break;
            default:
              destination3 = "";
              destination4 = "";
              destination5 = "";
              break;
          }
          this.nextTicket.GenelBilgileri.Parkurlar.Parkur1 = destination1;
          this.nextTicket.GenelBilgileri.Parkurlar.Parkur2 = destination2;
          this.nextTicket.GenelBilgileri.Parkurlar.Parkur3 = destination3;
          this.nextTicket.GenelBilgileri.Parkurlar.Parkur4 = destination4;
          this.nextTicket.GenelBilgileri.Parkurlar.Parkur5 = destination5;

          this.nextTicket.GenelBilgileri.PnrNo = element.BookingCode;

       

          // yon bilgisi
          var ow = false;
          var rt = false;

          var fsCount = element.FlightSegments.length;

          if (fsCount == 1) {
            ow = true;
          } else {
            rt =
              element.FlightSegments[0].DepartureAirportCode ==
              element.FlightSegments[element.FlightSegments.length - 1]
                .ArrivalAirportCode;
          }
            this.nextTicket.UcusBilgileri={};
          this.nextTicket.UcusBilgileri.UcusListesi=[];
          this.nextTicket.UcusBilgileri.UcusTarihi=element.FlightSegments[0].DepartureDateTime;

          for (const ucus of element.FlightSegments) {
       var ucusprm={Aktarma:ucus.IsConnected,BiletNo:this.nextTicket.GenelBilgileri.BiletNo,FareBases:breakdown.BaseFare,Formno:this.nextTicket.GenelBilgileri.Formno,Parkur:ucus.DepartureAirportCode,VarisParkur:ucus.ArrivalAirportCode,
        ParkurNo:index + 1,SirketKodu:credentials.SirketKodu,UcusClass:ucus.BookingClass,UcusClassTip:ucus.CabinType,UcusHY:ucus.MarkettingAirline,UcusNo:ucus.FlightNumber.slice(-4),UcusSaat:ucus.DepartureTime,UcusTarihi:ucus.DepartureDateTime, VarisSaat:ucus.ArrivalTime,VarisTarihi:ucus.ArrivalDateTime
       }
      //  ucus.FlightNumber.replace(ucus.MarkettingAirline,'')
       this.nextTicket.UcusBilgileri.UcusListesi.push(ucusprm);
}
          if (rt && element.FlightSegments.length>1){
            this.nextTicket.UcusBilgileri.UcusDonusTarihi=element.FlightSegments[element.FlightSegments.length-1].DepartureDateTime;
          }
          if (ow) {
            this.nextTicket.GenelBilgileri.BiletYon = "T";
          } else if (rt) {
            this.nextTicket.GenelBilgileri.BiletYon = "C";
          } else {
            this.nextTicket.GenelBilgileri.BiletYon = "T";
          }

          var passenger = val.Passengers.find(
            (x) => x.PaxReferanceId == breakdown.PaxReference.PaxReferanceId
          );
          this.nextTicket.GenelBilgileri.YolcuAdi =
            passenger.FirstName + " " + passenger.LastName;
          this.nextTicket.GenelBilgileri.FiyatTur = passenger.PaxType;
          this.nextTicket.GenelBilgileri.HesKodu = passenger.HesCode;
          this.nextTicket.GenelBilgileri.Email =
            this.updatePassengerItem.Contact.Email;
          this.nextTicket.GenelBilgileri.BiletTel =
            this.updatePassengerItem.Contact.Phone;
           this.nextTicket.OdemeBilgileri.MakbuzNo= breakdown.TicketNumber;

          
 var url =
                        "#/bilet/yeni/id?" +
                        "isl=get&hyolukod=" +
                        this.nextTicket.GenelBilgileri.HavaYoluKodu +
                        "&biletno=" +
                        this.nextTicket.GenelBilgileri.BiletNo +
                        "&ucustipi=" +
                        this.nextTicket.GenelBilgileri.UcusTipi +
                        "&tab=0";
                      location.href = url;
                      location.reload();
           
           
          
        }
      });
    },
    sendNextTicket(val) {
     
      let ticketno=null;
      this.loadingvmodel = true;
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
       
      
const flight = val.AirBookings[0].FlightSegments[0];

const isDomestic = flight.DepartureCountryName === flight.ArrivalCountryName;


      this.nextTicket.GenelBilgileri.SirketKodu = credentials.SirketKodu;

      val.AirBookings.forEach((element) => {
        for (
          let index = 0;
          index < element.PassengerBreakdowns.length;
          index++
        ) {
          const breakdown = element.PassengerBreakdowns[index];
          var bookingcode=element.BookingCode;  
       
          if (bookingcode==breakdown.TicketNumber){
this.nextTicket.GenelBilgileri.BiletNo="0";
this.nextTicket.otomatikBiletNo=true;
 this.nextTicket.GenelBilgileri.HavaYoluKodu =element.FlightSegments[0].MarkettingAirline;
          }else{
           this.nextTicket.GenelBilgileri.BiletNo =
            breakdown.TicketNumber.substring(3);
            ticketno=breakdown.TicketNumber.substring(3);
           
           this.nextTicket.GenelBilgileri.Formno =
            breakdown.TicketNumber.substring(0, 3);
            this.nextTicket.GenelBilgileri.HavaYoluKodu =
            element.FlightSegments[0].MarkettingAirline;
          }
        

          


          this.nextTicket.GenelBilgileri.Acente = "";
          this.nextTicket.GenelBilgileri.AcenteKodu = "";
          if (this.Provider=="Turna"){
             this.nextTicket.GenelBilgileri.Acente = "A";
             this.nextTicket.GenelBilgileri.AcenteKodu = this.prmAcenteKodu;
          }
          this.nextTicket.GenelBilgileri.ArkmanUsers = "WEB";
          this.nextTicket.GenelBilgileri.Crs = "ArkmanAktarim";

           if (this.makePaymentItem.PaymentType=="CreditCardPayment"){
            this.nextTicket.OdemeBilgileri.SatisSekli="F";
            this.nextTicket.OdemeBilgileri.KomisyonTip="K";
            this.nextTicket.OdemeBilgileri.KrediKartBilgi.KrediKartNo=this.maskCardNumber(this.PaymentForm.CardNumber);
            this.nextTicket.OdemeBilgileri.KrediKartBilgi.KrediKartTip="F";
           }
          
        if (!isDomestic)
        {
 this.nextTicket.GenelBilgileri.UcusTipi = "D";
 this.nextTicket.TanimBilgileri.ServisKod="21";
        }else{
 this.nextTicket.GenelBilgileri.UcusTipi = "I";
 this.nextTicket.TanimBilgileri.ServisKod="11";
        }
          //Sadece dis hatlar mi olacak ?
          if (this.$route.query.islem == "new") {
            this.nextTicket.GenelBilgileri.MusteriKodu.Kod = this.CurrentCode;
          }
          this.nextTicket.GenelBilgileri.MusteriKodu.Unvan =
            val.BillingInformation.BillingName;

          var analysisprice =
            breakdown.TotalMarkupFare + breakdown.TotalMarkupFareList;

          var baseFare = breakdown.BaseFare;
          // var serviceFee =
          //   breakdown.TotalServiceFee +
          //   analysisprice -
          //   passenger.ExtraPosAmount;

          baseFare -= analysisprice;

          // Tutar Bilgileri

          this.nextTicket.TutarBilgileri.NetTutar.NetTutar =
            this.footerTotalFare;
          this.nextTicket.TutarBilgileri.TaxTutar.TaxTutar =
            this.footerTotalTax;
          this.nextTicket.TutarBilgileri.ServisTutar.ServisTutar =
            this.footerTotalMarkupFare;
          this.nextTicket.TutarBilgileri.Tutar.Tutar = this.footerBaseFare;
          this.nextTicket.NotlarBilgileri.RefFare = this.footerBaseFare;
          this.nextTicket.NotlarBilgileri.LowFare =
            this.footerBaseFare - this.footerTotalMarkupFare;
          // this.nextTicket.TutarBilgileri.DigerServisTutar.DigerServisTutar = passenger.ExtraPosAmount;
          this.nextTicket.TutarBilgileri.Kur = val.Currency;

          this.nextTicket.TanimBilgileri.AnalizKod.AnalizTutar = analysisprice;
          this.nextTicket.TanimBilgileri.AnalizKod.AnalizKod = "KOM";

          this.nextTicket.TarihBilgileri.SatisTarihi = helpers.getDateNow();
          this.nextTicket.TarihBilgileri.OdemeTarihi = helpers.getDateNow();

          var destination1 = element.FlightSegments[0].DepartureAirportCode;
          var destination2 = element.FlightSegments[0].ArrivalAirportCode;
          var destination3;
          var destination4;
          var destination5;

          switch (element.FlightSegments.length) {
            case 2:
              destination3 = element.FlightSegments[1].ArrivalAirportCode;
              destination4 = "";
              destination5 = "";
              break;
            case 3:
              destination3 = element.FlightSegments[1].ArrivalAirportCode;
              destination4 = element.FlightSegments[2].ArrivalAirportCode;
              destination5 = "";
              break;
            case 4:
              destination3 = element.FlightSegments[1].ArrivalAirportCode;
              destination4 = element.FlightSegments[1].DepartureAirportCode;
              destination5 = element.FlightSegments[3].ArrivalAirportCode;
              break;
            case 5:
              destination3 = element.FlightSegments[
                element.FlightSegments.length - 1
              ].find((x) => x.DirectionInd == 0).ArrivalAirportCode;
              destination4 = element.FlightSegments[
                element.FlightSegments.length - 1
              ].find((x) => x.DirectionInd == 1).DepartureAirportCode;
              destination5 = element.FlightSegments[
                element.FlightSegments.length - 1
              ].find((x) => x.DirectionInd == 1).ArrivalAirportCode;
              break;
            case 6:
              destination3 = element.FlightSegments[
                element.FlightSegments.length - 1
              ].find((x) => x.DirectionInd == 0).ArrivalAirportCode;
              destination4 = element.FlightSegments[
                element.FlightSegments.length - 1
              ].find((x) => x.DirectionInd == 1).DepartureAirportCode;
              destination5 = element.FlightSegments[
                element.FlightSegments.length - 1
              ].find((x) => x.DirectionInd == 1).ArrivalAirportCode;
              break;
            case 7:
              destination3 = element.FlightSegments[1].DepartureAirportCode;
              destination4 = element.FlightSegments[2].ArrivalAirportCode;
              destination5 = element.FlightSegments[3].ArrivalAirportCode;
              break;
            default:
              destination3 = "";
              destination4 = "";
              destination5 = "";
              break;
          }
          this.nextTicket.GenelBilgileri.Parkurlar.Parkur1 = destination1;
          this.nextTicket.GenelBilgileri.Parkurlar.Parkur2 = destination2;
          this.nextTicket.GenelBilgileri.Parkurlar.Parkur3 = destination3;
          this.nextTicket.GenelBilgileri.Parkurlar.Parkur4 = destination4;
          this.nextTicket.GenelBilgileri.Parkurlar.Parkur5 = destination5;

          this.nextTicket.GenelBilgileri.PnrNo = element.BookingCode;

       

          // yon bilgisi
          var ow = false;
          var rt = false;

          var fsCount = element.FlightSegments.length;

          if (fsCount == 1) {
            ow = true;
          } else {
            rt =
              element.FlightSegments[0].DepartureAirportCode ==
              element.FlightSegments[element.FlightSegments.length - 1]
                .ArrivalAirportCode;
          }
            this.nextTicket.UcusBilgileri={};
          this.nextTicket.UcusBilgileri.UcusListesi=[];
          this.nextTicket.UcusBilgileri.UcusTarihi=element.FlightSegments[0].DepartureDateTime;

          for (const ucus of element.FlightSegments) {
       var ucusprm={Aktarma:ucus.IsConnected,BiletNo:this.nextTicket.GenelBilgileri.BiletNo,FareBases:breakdown.BaseFare,Formno:this.nextTicket.GenelBilgileri.Formno,Parkur:ucus.DepartureAirportCode,VarisParkur:ucus.ArrivalAirportCode,
        ParkurNo:index + 1,SirketKodu:credentials.SirketKodu,UcusClass:ucus.BookingClass,UcusClassTip:ucus.CabinType,UcusHY:ucus.MarkettingAirline,UcusNo:ucus.FlightNumber.slice(-4),UcusSaat:ucus.DepartureTime,UcusTarihi:ucus.DepartureDateTime, VarisSaat:ucus.ArrivalTime,VarisTarihi:ucus.ArrivalDateTime
       }
      //  ucus.FlightNumber.replace(ucus.MarkettingAirline,'')
       this.nextTicket.UcusBilgileri.UcusListesi.push(ucusprm);
}
          if (rt && element.FlightSegments.length>1){
            this.nextTicket.UcusBilgileri.UcusDonusTarihi=element.FlightSegments[element.FlightSegments.length-1].DepartureDateTime;
          }
          if (ow) {
            this.nextTicket.GenelBilgileri.BiletYon = "T";
          } else if (rt) {
            this.nextTicket.GenelBilgileri.BiletYon = "C";
          } else {
            this.nextTicket.GenelBilgileri.BiletYon = "T";
          }

          var passenger = val.Passengers.find(
            (x) => x.PaxReferanceId == breakdown.PaxReference.PaxReferanceId
          );
          this.nextTicket.GenelBilgileri.YolcuAdi =
            passenger.FirstName + " " + passenger.LastName;
          this.nextTicket.GenelBilgileri.FiyatTur = passenger.PaxType;
          this.nextTicket.GenelBilgileri.HesKodu = passenger.HesCode;
          this.nextTicket.GenelBilgileri.Email =
            this.updatePassengerItem.Contact.Email;
          this.nextTicket.GenelBilgileri.BiletTel =
            this.updatePassengerItem.Contact.Phone;
           this.nextTicket.OdemeBilgileri.MakbuzNo= breakdown.TicketNumber;

           if (!this.pdfactive){
this.$http
            .post(auth.API_URL + "api/Ticket/TicketAdd", this.nextTicket, {
              headers: {
                Authorization: "Bearer " + auth.getAuthHeader(),
              },
            })
            .then(
              (response) => {
                 this.text1 = this.$t(response.body.ResponseMessage);
                this.snackbar = true;
                this.loadingvmodel = false;
                if (response.body.Status != Boolean(false)) {
                  this.loadingvmodel = false;
                  this.snackbar = true;
                  this.snackbarkColor = "success";
                  this.text1 = "Bilet Kayıt İşlemi Tamamlandı.";
                 
                  setTimeout(
                    function () {
                      var url =
                        "#/bilet/yeni/id?" +
                        "isl=get&hyolukod=" +
                        this.nextTicket.GenelBilgileri.HavaYoluKodu +
                        "&biletno=" +
                        this.nextTicket.GenelBilgileri.BiletNo +
                        "&ucustipi=" +
                        this.nextTicket.GenelBilgileri.UcusTipi +
                        "&tab=0";
                      location.href = url;
                      location.reload();
                    }.bind(this),
                    3000
                  );
              //      setTimeout(
              //   function () {
              //     var url = "#/satis/ucus/liste";
              //     location.href = url;
              //     location.reload();
              //   }.bind(this),
              //   3000
              // );
                  this.loadingvmodel=false;
                } else {
                   this.text1 = this.$t(response.body.ResponseMessage);
                  this.snackbar = true;
                  this.loadingvmodel = false;
                }
              },
              (response) => {
                 this.text1 = this.$t(response.body.ResponseMessage);
                this.snackbar = true;
                this.loadingvmodel=false;
                if (response.status === 0) {
                  this.text1 = "Service Unavailable";
                  this.snackbar = true;
                } else {
                   this.text1 = this.$t(response.body.ResponseMessage);
                  this.snackbar = true;
                }
              }
            );
           }else
           {
             this.imageUrlToBase64(this.getImgUrl(this.nextTicket.GenelBilgileri.HavaYoluKodu)).then(base64 => {
 this.nextTicket.PdfLang = "tr";
    this.nextTicket.PdfShowAmount = true;
             let credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.$http.post(auth.API_URL+'api/Ticket/TicketPdfDownload', {Bilet :this.nextTicket,logo:base64}, {
      headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
        'CariSirketNo': credentials.SirketKodu.toString(),
        'CoperSirketNo': credentials.CoperSirketNo.toString(),
        'MuhasebeSirketNo': credentials.MuhasebeSirketNo.toString(),
          },
      responseType: "arraybuffer"
      
    }).then(response => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = "TicketInvoice.pdf";
      link.click();
       this.loadingvmodel = false;
       this.pdfactive=false;
    }).catch(error => {
      console.error("PDF indirilemedi", error);
      this.text1 = this.$t('PDF-could-not-be-downloaded');
      this.snackbar = true;
      console.log("Token:", auth.getAuthHeader());
       this.loadingvmodel = false;
       this.pdfactive=false;
    });
 
             })
           
    
           }
          
        }
      });
    },
    addPassengerstoCoper(val){
      console.log(val);
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
if (this.$route.query.islem == "new"){
  for (const element of val) {
     let adres={};
     adres.SirketNo = credentials.CoperSirketNo;
     adres.Ad=element.FirstName;
     adres.DogumTarihi=element.BirthDate;
     adres.Email=element.Email;
     adres.GSM=element.Phone;
     adres.PasaportNo=element.PassportNo;
     adres.Soyad=element.LastName;
     adres.TCKimlikNo=element.CitizenNo;
     adres.BitisTarihi=element.PassportExpireDate;
     adres.Cinsiyet=1;
 var params = {
        Value: adres
      }
      tool.http_post(this, 'AdresInsert', params).then(
        response => {
         
          if (response.body.Status == true) {
           

          } 
        },
        response => {
          

          
        }
      );
    }
}


    },
    getBillingInfo() {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
      var params = {
        Code: this.cariItem,
        CompanyCode: credentials.SirketKodu,
      };

      this.$http
        .post(auth.API_URL + "api/Current/Get", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.CurrentCode = response.body.Code;
            this.billingInformationItem.BillingInformation.BillingName =
              response.body.Title;
            this.billingInformationItem.BillingInformation.Address =
              response.body.Invoice.Address;
            this.billingInformationItem.BillingInformation.City =
              response.body.Invoice.Province;
            this.billingInformationItem.BillingInformation.TaxOffice =
              response.body.Invoice.TaxOffice;
            this.billingInformationItem.BillingInformation.TaxNo =
              response.body.Invoice.TaxNumber;

            //this.billingSubmit();
          },
          (response) => {
            if (response.status === 0) {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
            } else {
              this.text1 = response.statusText;
              this.snackbar = true;
            }
          }
        );
    },
    billingSubmit(val) {
      
      this.loadingvmodel = true;
      var bookingParams = JSON.parse(
        window.localStorage.getItem("bookingParams")
      );
      // if (this.billingInformationItem.BillingInformation.TaxNo != "") {
        this.billingInformationItem.SessionHeader.SessionId =
          bookingParams.SessionId;
        this.billingInformationItem.SessionHeader.SessionToken =
          bookingParams.SessionToken;
        this.billingInformationItem.ShoppingCartId =
          window.localStorage.getItem("shopCartID");

        this.$http
          .post(
            auth.BOOKING_API_URL + "Billing/Submit",
            this.billingInformationItem
          )
          .then(
            (response) => {
              if (!response.body.HasError) {
                this.makePrebooking(val);
              } else {
                this.text1 = response.body.ServiceError.ErrorMessages[0];
                this.snackbar = true;
                this.loadingvmodel = false;
                this.snackbarkColor = "warning";
                this.unLockShoppingCart();
              }
            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable-Air/Submit";
                this.snackbar = true;
                this.loadingvmodel = false;
              } else {
                this.text1 = "Service Unavailable-Air/Submit";
                this.snackbar = true;
                this.loadingvmodel = false;
              }
            }
          );
      // } else {
      //   setTimeout(() => {
      //     this.billingSubmit(val);
      //   }, 1500);
      // }
    },
    makePayment() {

      if (this.Provider=="Turna"){
     
        if (this.prmAcenteKodu=='' || this.prmAcenteKodu==null){
          alert('Turna Acente Kodu Bulunamadı..');
          return;
        }
      }
      
      var bookingParams = JSON.parse(
        window.localStorage.getItem("bookingParams")
      );
      // / this.currencyValue;
      var Amount = (this.footerTotalFare * 1) ;

    if (this.isUpdate){
      this.grandTotal=Amount;
    }
    if (Amount!=this.grandTotal && this.isUpdate==false)
    {
      if (confirm('Değerli kullanıcımız, bilet fiyatınız değişti, lütfen son fiyatı kontrol ediniz. Geçerli Fiyat:' + ' ' + this.grandTotal + ' ' + ', Bu Fiyatı Onaylıyor musunuz..?') == true) {
  } else {
      return;
  }
      
    }
 this.loadingvmodel = true;
      this.makePaymentItem.SessionHeader.SessionId = bookingParams.SessionId;
      this.makePaymentItem.SessionHeader.SessionToken =
        bookingParams.SessionToken;
      this.makePaymentItem.ShoppingCartId =
        window.localStorage.getItem("shopCartID");
      this.makePaymentItem.Amount = this.grandTotal;

      if (this.makePaymentItem.PaymentType=="CreditCardPayment"){
      this.PaymentForm.ExpirationYear=   this.PaymentForm.ExpirationYear.slice(-2);
        this.makePaymentItem.PaymentForm=this.PaymentForm;
        this.makePaymentItem.PaymentForm.InstallmentId= this.makePaymentItem.ShoppingCartId;
      }
      this.$http
        .post(auth.BOOKING_API_URL + "MakePayment", this.makePaymentItem)
        .then(
          (response) => {
            if (!response.body.HasError) {
              this.finalizeShopping();
            } else {
              this.text1 = response.body.ServiceError.ErrorMessages[0];
              this.snackbar = true;
              this.loadingvmodel = false;
              this.snackbarkColor = "warning";
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Payment/MakePayment";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-Payment/MakePayment";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    finalizeShopping() {
      var bookingParams = JSON.parse(
        window.localStorage.getItem("bookingParams")
      );

      this.finalizeShoppingItem.SessionHeader.SessionId =
        bookingParams.SessionId;
      this.finalizeShoppingItem.SessionHeader.SessionToken =
        bookingParams.SessionToken;
      this.finalizeShoppingItem.ShoppingCartId =
        window.localStorage.getItem("shopCartID");

      this.$http
        .post(
          auth.BOOKING_API_URL + "Air/FinalizeShopping",
          this.finalizeShoppingItem
        )
        .then(
          (response) => {
            if (!response.body.HasError) {
              
             this.sendNextTicket(response.body.ShoppingCart);
             
              //Bilet kayiti booking apiye alindi.
             
            } else {
              this.text1 = response.body.ServiceError.ErrorMessages[0];
              this.snackbar = true;
              this.loadingvmodel = false;
              this.snackbarkColor = "warning";
            }
          },
          (response) => {
            if (response.body && response.body.HasError && response.body.ServiceError) {
              this.text1 = response.body.ServiceError.ErrorMessages[0];
              this.snackbarkColor = "warning";
            } else {
              this.text1 = "Service Unavailable-Air/FinalizeShopping";
            }
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        );
    },
    makePrebooking(val) {
      this.grandTotal=0;
       this.loadingvmodel = true;
      //val 1 : prebooking val 2 : booking
      var bookingParams = JSON.parse(
        window.localStorage.getItem("bookingParams")
      );
      if (val == 1) {
        this.makePrebookingItem.ContinueWithoutReservation = false;
      } else {
        this.makePrebookingItem.ContinueWithoutReservation = true;
      }
      this.makePrebookingItem.SessionHeader.SessionId = bookingParams.SessionId;
      this.makePrebookingItem.SessionHeader.SessionToken =
        bookingParams.SessionToken;
      this.makePrebookingItem.ShoppingCartId =
        window.localStorage.getItem("shopCartID");
      this.$http
        .post(
          auth.BOOKING_API_URL + "Air/MakePrebooking",
          this.makePrebookingItem
           
        )
        .then(
          (response) => {
            if (!response.body.HasError) {
              if (val == 1) {
                this.loadingvmodel = false;
                this.snackbar = true;
                this.snackbarkColor = "success";
                this.text1 = "Ön Rezervasyon İşlemi Tamamlandı.";
                setTimeout(
                  function () {
                    var url1 =
                      "#/satis/ucus/islem/id?" +
                      "isl=get&pnr=" +
                      response.body.ShoppingCart.AirBookings[0].BookingCode;
                    location.href = url1;
                    location.reload();
                  }.bind(this),
                  3000
                );
              } else {
                 if (response.body && !response.body.HasError && response.body.ShoppingCart){
 this.grandTotal = response.body.ShoppingCart.ShoppingSummary.GrandTotal;
                this.makePayment();
                 }else{
                   this.text1 = "Shopping Card Okunamadı..!!";
              this.snackbar = true;
              this.loadingvmodel = false;
              this.snackbarkColor = "warning";
                 }
               
              }
            } else {
              this.text1 = response.body.ServiceError.ErrorMessages[0];
              this.snackbar = true;
              this.loadingvmodel = false;
              this.snackbarkColor = "warning";
              this.unLockShoppingCart();
            }
          },
          (response) => {
             if (response.body && response.body.HasError && response.body.ServiceError) {
              this.text1 = response.body.ServiceError.ErrorMessages[0];
              this.snackbarkColor = "warning";
            } else {
              this.text1 = "Service Unavailable-Air/MakePrebooking";
            }
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        );
    },
    updatePassenger(val) {
      //val 1 : prebooking val 2 : booking
    
 
      if (this.isInternational==true){
         const missing = (this.paxList || []).some(p =>
        !p.PassportNo || !p.PassportNo.toString().trim() || !p.PassportExpireDate
      );
      if (missing) {
        this.text1 = this.$t("Please-fill-in-the-required-fields.");
        this.snackbar = true;
        this.loadingvmodel = false;
        this.snackbarkColor = "warning";
        return;
      }
 for (const element of this.paxList) {
    element.CitizenNo="00000000000";
}
      }
     
      this.loadingvmodel = false;
      if (this.$refs.formTicket.validate()) {
        this.loadingvmodel = true;
        if (this.cariItem != null) {
          this.getBillingInfo();
        }

        var bookingParams = JSON.parse(
          window.localStorage.getItem("bookingParams")
        );

        let params = {};

        params = JSON.parse(JSON.stringify(this.updatePassengerItem));

        params.SessionHeader.SessionId = bookingParams.SessionId;
        params.SessionHeader.SessionToken = bookingParams.SessionToken;
        params.Passengers = this.paxList;
        params.ShoppingCartId = window.localStorage.getItem("shopCartID");

        params.Contact.Phone = params.Contact.Phone;//this.checkPhoneFormat();

        params.Passengers.forEach((element) => {
          element.Phone =element.Phone;//  this.checkPhoneFormat();
          element.BirthDate =element.BirthDate.split("T")[0];

          if (element.PassportExpireDate == "0001-01-01T00:00:00" || element.PassPortExpireDate=="" || element.PassportExpireDate==null) {
            var today = new Date()
            element.PassportExpireDate = today;
          }
        });

        this.$http
          .post(auth.BOOKING_API_URL + "Air/UpdatePassengers", params)
          .then(
            (response) => {
              if (!response.body.HasError) {
                this.loadingvmodel = false;
                 this.addPassengerstoCoper(params.Passengers);
                this.billingSubmit(val);
              } else {
                this.text1 = response.body.ServiceError.ErrorMessages[0];
                this.snackbar = true;
                this.loadingvmodel = false;
                this.snackbarkColor = "warning";
               
              }
            },
            (response) => {
              if (response.body && response.body.HasError && response.body.ServiceError) {
              this.text1 = response.body.ServiceError.ErrorMessages[0];
              this.snackbarkColor = "warning";
            } else {
              this.text1 = "Service Unavailable-Air/UpdatePassengers";
            }
            this.snackbar = true;
            this.loadingvmodel = false;
          }
          );
      } else {
        this.text1 = this.$t('Please-fill-in-the-required-fields.');
        this.snackbar = true;
        this.loadingvmodel = false;
        this.snackbarkColor = "warning";
      }
    },
    unLockShoppingCart(){
       this.loadingvmodel = true;

  const bookingParams = JSON.parse(window.localStorage.getItem("bookingParams"));

  
  if (!bookingParams || !bookingParams.SessionId || !bookingParams.SessionToken) {
    this.text1 = "bookingParams bulunamadı / eksik";
    this.snackbar = true;
    this.loadingvmodel = false;
    return;
  }

  const params = {
    SessionHeader: {
      SessionId: bookingParams.SessionId,
      SessionToken: bookingParams.SessionToken,
    },
    ShoppingCartId: window.localStorage.getItem("shopCartID"),
  };
        this.$http
          .post(auth.BOOKING_API_URL + "Air/UpdatePassengers", params)
          .then(
            (response) => {
              if (response.body.HasError) {
                this.text1 = response.body.ServiceError.ErrorMessages[0];
                this.snackbar = true;
                this.loadingvmodel = false;
                this.snackbarkColor = "warning";
              } 
              else{
                  this.loadingvmodel = false;
              }
            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable-Air/UpdatePassengers";
                this.snackbar = true;
                this.loadingvmodel = false;
              } else {
                this.text1 = "Service Unavailable-Air/UpdatePassengers";
                this.snackbar = true;
                this.loadingvmodel = false;
              }
            }
          );
    },
    toNumber(val) {
    if (val == null) return 0;
    return parseFloat(val.toString().replace(/,/g, "")) || 0;
  },
    calculateFooter() {

 this.footerBaseFare = 0;
    this.footerTotalTax = 0;
    this.footerTotalServiceFee = 0;
    this.footerLateInterest = 0;
    this.footerTotalMarkupFare = 0;
    this.footerTotalMarkupFareList = 0;
    this.footerTotalFare = 0;

    
    (this.ticketAllocate || []).forEach(ticket => {
      (ticket.PassengerBreakdowns || []).forEach(element => {
        this.footerBaseFare += this.toNumber(element.BaseFare);
        this.footerTotalTax += this.toNumber(element.TotalTax);
        this.footerTotalServiceFee += this.toNumber(element.TotalServiceFee);
        this.footerLateInterest += this.toNumber(element.TotalLateInterest);
        this.footerTotalMarkupFare += this.toNumber(element.TotalMarkupFare);
        this.footerTotalMarkupFareList += this.toNumber(element.TotalMarkupFareList);
        this.footerTotalFare += this.toNumber(element.TotalFare);
      });
    });


      //todo
      // this.ticketAllocate[0].PassengerBreakdowns.forEach((element) => {
      //   this.footerBaseFare =
      //     parseFloat(this.footerBaseFare) +
      //     parseFloat(element.BaseFare.toString().replace(/,/g, ""));
      //   this.footerTotalTax =
      //     parseFloat(this.footerTotalTax) +
      //     parseFloat(element.TotalTax.toString().replace(/,/g, ""));
      //   this.footerTotalServiceFee =
      //     parseFloat(this.footerTotalServiceFee) +
      //     parseFloat(element.TotalServiceFee.toString().replace(/,/g, ""));

      //   this.footerLateInterest =
      //     parseFloat(this.footerLateInterest) +
      //     parseFloat(element.TotalLateInterest.toString().replace(/,/g, ""));

      //   this.footerTotalMarkupFare =
      //     parseFloat(this.footerTotalMarkupFare) +
      //     parseFloat(element.TotalMarkupFare.toString().replace(/,/g, ""));

      //   this.footerTotalMarkupFareList =
      //     parseFloat(this.footerTotalMarkupFareList) +
      //     parseFloat(element.TotalMarkupFareList.toString().replace(/,/g, ""));

      //   this.footerTotalFare =
      //     this.footerTotalFare +
      //     parseFloat(element.TotalFare.toString().replace(/,/g, ""));
      // });
    },
    calculateHourAndMinute(value) {
      var hours = value / 60;
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      if (rhours == 0) {
        return rminutes + " dakika";
      } else if (rminutes == 0) {
        return rhours + " saat ";
      } else {
        return rhours + " sa " + rminutes + " dk";
      }
    },
    getImgUrl(img) {
      return logoo.logoControl(img);
    },
    setCurrency(val) {
      this.currencyValue = val;
    },
    allocated() {
      this.loadingvmodel = true;
      var allocateParams = JSON.parse(
        window.localStorage.getItem("allocateParams")
      );

      this.$http
        .post(auth.BOOKING_API_URL + "Air/Allocate", allocateParams)
        .then(
          (response) => {
            if (!response.body.HasError) {
const isInternationalprm =  response.body.ShoppingCart.AirBookings[0].IsInternational;
this.isInternational=isInternationalprm;

// if (isInternational) {
//    console.log("Yurtdışı uçuş");
// } else {
//    console.log("Yurtiçi uçuş");
// }

              this.ticketAllocate = response.body.ShoppingCart.AirBookings;
 const prv = response.body.ShoppingCart.AirBookings[0].Provider;
 this.Provider=prv;
 
              this.ticketAllocate.forEach((data) => {
                for (
                  let index = 0;
                  index < data.PassengerBreakdowns.length;
                  index++
                ) {
                  const element = data.PassengerBreakdowns[index];

                  element.BaseFare = this.moneyformat(element.BaseFare);
                  element.TotalFare = this.moneyformat(element.TotalFare );
                  element.TotalLateInterest = this.moneyformat(element.TotalLateInterest );
                  element.TotalMarkupFare = this.moneyformat(element.TotalMarkupFare);
                  element.TotalMarkupFareList = this.moneyformat(element.TotalMarkupFareList);
                  element.TotalServiceFee = this.moneyformat(element.TotalServiceFee);
                  element.TotalTax = this.moneyformat(element.TotalTax);
                }
              });

              window.localStorage.setItem(
                "shopCartID",
                response.body.ShoppingCart.Id
              );

              this.passengerList =
                response.body.ShoppingCart.AirBookings[0].PassengerBreakdowns;
              this.passengerList.forEach((element) => {
                var passenger = Airports.passenger();

               if (this.$route.query.islem == "new"){
                passenger.WheelChairService=0;
                
               }
                passenger.PaxType = element.PaxReference.PaxCode;
                passenger.PaxReferanceId = element.PaxReference.PaxReferanceId;
                this.paxList.push(passenger);
              });

              this.loadingvmodel = false;
              this.calculateFooter();
              console.log("ticketAllocate:")
console.log(this.ticketAllocate);
            } else {
              this.text1 = response.body.ServiceError.ErrorMessages[0];
              this.snackbar = true;
              this.loadingvmodel = false;
              this.snackbarkColor = "warning";
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Air/Allocate";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-Air/Allocate";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
  },
  watch: {
    "paxs.FirstName": function (val) {
      console.log("TEST  = " + val);
    },
  },
  filters: {
    passengerType: function (val) {
      return Airports.passengerType(val);
    },
      moneyformat: function (m) {
                return helpers.moneyformat(m);
            },

  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    caricomp,
    tarihim,
    doviz,
    phoneinput
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    //this.$refs.doviz.getCurrencyValue("EUR");
this.loadingvmodel=true;
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
 this.getProviders();
    if (this.sayfayetki.Status == true) {
      
      //YETKİ OK
          if (this.$route.query.islem == "new") {
          this.isUpdate = false;
          
          this.flightType = window.localStorage.getItem("flightType");
          this.allocated();
          
console.log("international:");
 console.log( this.isInternational);
          setTimeout(() => {
            this.countryItems.sort(function (a, b) {
              if (a.name != null && b.name != null) {
                var nameA = a.name.toLowerCase(),
                  nameB = b.name.toLowerCase();
                if (nameA < nameB)
                
                  return -1;
                if (nameA > nameB) return 1;
                return 0; //default return value (no sorting)
              }
            });
          }, 1500);
        } else {
          this.loadingvmodel = true;
          this.isUpdate = true;
          var bookingParams = JSON.parse(
            window.localStorage.getItem("bookingParams")
          );

          let params = {
            SessionHeader: {
              SessionId: bookingParams.SessionId,
              SessionToken: bookingParams.SessionToken,
            },
            ShoppingCartId: window.localStorage.getItem("shopCartID"),
          };

          this.$http.post(auth.BOOKING_API_URL + "GetShoppingCart", params).then(
            (response) => {
              if (!response.body.HasError) {
                this.ShoppingCard=response.body.ShoppingCart;

if (this.ShoppingCard.PaymentHistories[0].PaymentHistoryType=="CREDITCARD"){
  
  this.makePaymentItem.PaymentType="CreditCardPayment";
  this.makePaymentItem.PayableBank="5";
  this.PaymentForm.CardNumber=this.ShoppingCard.PaymentHistories[0].PaymentHistoryType.CreditCardNumber;
}

                const pnr = response.body.ShoppingCart.AirBookings[0].BookingCode;
                const prv = response.body.ShoppingCart.AirBookings[0].Provider;
 this.PnrNo=pnr;
 this.Provider=prv;
 console.log(this.Provider);
 
 this.IsBooking=response.body.ShoppingCart.AirBookings[0].AirBookingStatus.IsBooking;
                this.ticketAllocate = response.body.ShoppingCart.AirBookings;
                this.IsCancelable = response.body.ShoppingCart.IsCancelable;
                this.ticketAllocate.forEach((data) => {
                  for (
                    let index = 0;
                    index < data.PassengerBreakdowns.length;
                    index++
                  ) {
                    const element = data.PassengerBreakdowns[index];
                    element.BaseFare = this.moneyformat(element.BaseFare);
                    element.TotalFare = this.moneyformat(element.TotalFare);
                    element.TotalLateInterest = this.moneyformat(element.TotalLateInterest);
                    element.TotalMarkupFare = this.moneyformat(element.TotalMarkupFare);
                    element.TotalMarkupFareList = this.moneyformat(element.TotalMarkupFareList);
                    element.TotalServiceFee = this.moneyformat(element.TotalServiceFee);
                    element.TotalTax = this.moneyformat(element.TotalTax);
                  }
                });

                window.localStorage.setItem(
                  "shopCartID",
                  response.body.ShoppingCart.Id
                );

                this.passengerList = response.body.ShoppingCart.Passengers;

                this.searchBillingInfo(
                  response.body.ShoppingCart.BillingInformation.BillingName
                );
                this.passengerList.forEach((element) => {
                  var passenger = Airports.passenger();
                  passenger = element;
                  // passenger.Phone = element.Phone.substring(element.Phone.length - 10);
                  // alert(passenger.Phone);
                  this.paxList.push(passenger);
                });
                this.updatePassengerItem.Contact =
                  response.body.ShoppingCart.Contact;
                this.updatePassengerItem.Contact.Phone =
                  response.body.ShoppingCart.Contact.Phone.substring(4);
                this.updatePassengerItem.Notes =
                  response.body.ShoppingCart.Notes +
                  "  Rerzervasyon Tarihi = " +
                  response.body.ShoppingCart.CreatedAt;
                this.loadingvmodel = false;
                this.calculateFooter();
              } else {
                this.text1 = response.body.ServiceError.ErrorMessages[0];
                this.snackbar = true;
                this.loadingvmodel = false;
                this.snackbarkColor = "warning";
              }
              if (this.IsBooking){
               
this.searchTicketNo();
              }
              
            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable-Air/GetShoppingCart";
                this.snackbar = true;
                this.loadingvmodel = false;
              } else {
                this.text1 = "Service Unavailable-Air/GetShoppingCart";
                this.snackbar = true;
                this.loadingvmodel = false;
              }
            }
          );
          
        }
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    }
  },
};
</script>

<style>
</style>

